import React, { createContext, useState } from 'react';

export const BlogContext = createContext();

export const BlogProvider = ({ children }) => {
  const [currentBlogTag, setCurrentBlogTag] = useState('Featured');
  const [featuredLabel, setFeaturedLabel] = useState('Featured');

  const value = {
    currentBlogTag,
    setCurrentBlogTag,
    featuredLabel,
    setFeaturedLabel
  };

  return (
    <BlogContext.Provider value={value}>
      {children}
    </BlogContext.Provider>
  );
};

export default BlogContext;